import { useMemo } from "react";
import { useSelector } from "react-redux";
import { upperFirst } from "lodash";
import { Stack, Typography, CircularProgress } from "@financeable-com-au/financeable-ui";
// @ts-expect-error: ignoring as it is existing js file
import { applicationSelector } from "@/store/slices/applicationFormSlice";
import type { ApplicationFormSlice, ApplicationState } from "@/store/slices/types/applicationFormSlice";
import { useApplicationRouteType } from "@/components/SubmissionModal/hooks/useApplicationRouteType";

const SubmissionPending = () => {
  const applicationRouteType = useApplicationRouteType();
  const formattedApplicationRouteType = upperFirst(applicationRouteType);
  const { submissionModal } = useSelector<ApplicationFormSlice, ApplicationState>(applicationSelector);

  const pendingAction = useMemo(() => {
    if (submissionModal.submissionType === "email") {
      return "Emailing";
    }
    return "Uploading";
  }, [submissionModal.submissionType]);

  return (
    <Stack alignItems="center" rowGap={3} padding={8}>
      <CircularProgress />
      <Typography component="h2" id="modal-title" level="title-md">
        {pendingAction} {formattedApplicationRouteType}
      </Typography>
    </Stack>
  );
};

export { SubmissionPending };
